<template>

 

  <v-container grid-list-md fluid align-baseline pa-0>
<!--
<script2 src="https://maps.googleapis.com/maps/api/js?key=AIzaSyCsjfdV7bEDGipipk6ILx7BN2vJcL7g-fQ"></script2>
-->
<script2 src="https://www.google.com/jsapi"></script2>

  <v-layout row wrap>

      <div id="m2"></div>

    <v-snackbar
        v-if="snackbar"
        v-model="snackbar"
    >
        {{snackbarText}}
        <v-btn
            color="pink"
            flat
            @click="closeSnackBar"
        >
            Close
        </v-btn>                            
    </v-snackbar>

    <v-flex xs12>
        <gmap-map
        
        :center="mapcenter"
        :zoom="9"
        map-type-id="roadmap"
        style="width: 100%; height: 300px"
        >
        
        <gmap-marker
            v-if="checkinsActive"
            :key="index"
            v-for="(m, index) in checkinsActive"
            :position="m.position"
            :clickable="true"
            :draggable="false"
            @click="center=m.position"
        />
        
        </gmap-map>

   
        <v-card> 
            <v-card-text>   
                <v-layout row wrap pb-0> 
                <v-flex xs12>
                <div class="font-weight-medium title pt-3">What are you up to?...CHECK IN 
                
                </div>
                </v-flex>
                <v-flex xs12>
                <div class="caption grey--text pa-0">
                    Let your chapter members know where you are. Maybe someone will join in the fun.
                </div>
                </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-actions>
            <v-btn
              color="accent"
              dark
              absolute
              bottom
              right
              fab
              @click="getLocation"
            >
              <v-icon>add</v-icon>
            </v-btn>                  
            </v-card-actions>
        </v-card>
        <template  v-for="c in checkinsActive" v-if="checkinsActive">
        <v-card v-bind:key="c.position.lat" class="loc-card ma-2">
            <v-card-title>
                <v-flex xs12  pt-0 pb-0 v-if="c.placename">
                    <div v-if="c.placename" class="  pt-0 pb-0  font-weight-bold body-1">{{c.placename}} </div>
                </v-flex >
                <v-flex xs12 v-if="c.address"  pt-0 pb-0 >
                    <div v-if="c.address" class=" pt-0 pb-0  font-weight-bold body-1">{{c.address}} </div>
                </v-flex>
                <v-flex xs12  v-if="c.expiringdatetime"  pt-0 pb-0 >                    
                     <div v-bind:key="'expiration-' + c.position.lat" v-if="c.expiringdatetime" class="caption pl-2"><v-chip>{{c.activity}}</v-chip> until {{c.expiringdatetime}}</div>
                </v-flex>
                <v-flex xs12 >
                        <template v-if="c && member.userid ===c.userid" >
                        
                        <v-icon
                            color="primary"
                            size="30"
                            @click="viewCheckin(c)"
                        >
                            add_a_photo
                        </v-icon>
                        
                        </template>
                        <v-avatar
                            v-if="c.images && c.images.length>0"
                            :tile=true
                            size="60"
                            v-for="(image, imageIndex) in c.images"
                            :key="c.expiringdatetime + '-img-' + imageIndex"
                        >
                            <img :src="image.fileurl">
                        </v-avatar>                        
                </v-flex>                
            </v-card-title>
            <v-card-text>
                <v-layout row>
                <v-flex xs8  pt-0 pb-0 > 
                    <div v-if="c.name" class="primary--text text--darken-1 caption"><v-icon color="primary darken-1">person</v-icon>{{c.name}} - {{c.line}} </div>
                </v-flex>
                <v-flex xs3  pt-0 pb-0 mr-2 > 
                    <v-btn color="primary"
                        small
                        @click="viewCheckin(c)"
                    >
                    
                    More <v-icon>chevron_right</v-icon>
                    
                    </v-btn>
                </v-flex>
                 </v-layout>
                <v-layout row>
                <v-flex xs12  pt-0 pb-0 v-if="c.comment"> 
                    <div v-if="c.comment" class="grey--text comment pl-4" v-html="c.comment" ></div>
                </v-flex>
                </v-layout>
            </v-card-text>

        </v-card>

        </template>
    </v-flex>

            <v-layout row wrap>
                <v-flex xs12 pa-0>
                <v-dialog v-model="panel"
                fullscreen
                pa-0
                :hide-overlay=false
                
                >

                <v-layout>
                <v-flex xs12>
                    <v-toolbar dark color="primary">
                        <v-toolbar-side-icon @click="panel = false">
                        <v-icon>close</v-icon>
                                                        
                        </v-toolbar-side-icon>
                        <v-toolbar-title>Submit a Checkin </v-toolbar-title>

                    </v-toolbar>                           
                <v-card raised pa-2
                    height="895"
                >
                    
                    <v-card-title>
                        <v-layout row>
                            <v-flex xs12 pa-1>
                        <v-subheader class="title"><v-icon>where_to_vote</v-icon> Check In at this Location</v-subheader>
                            </v-flex>

                      
                        </v-layout>
                    </v-card-title>

                <v-card-text>
                <v-form v-model="validCheckin">
                <template v-if="address">
                    <v-subheader class="caption">Place Name:</v-subheader>
                    <v-text-field
                        v-model="placename"                        
                        solo
                        required
                        :rules="textfieldRules"
                    >

                    </v-text-field>   

                    <v-subheader class="caption">Address:</v-subheader>
                    <v-text-field
                    readonly
                    solo
                    :rules="textfieldRules"
                        v-model="address"
                    >

                    </v-text-field>
                 
                    <v-subheader class="caption">How long will you be there? (hrs)</v-subheader>
                    <v-select
                    v-model="durationvalue"
                    :items="durationOptions"
                    label="How long (hours) will you be there?"
                    required
                    :rules="dropdownRules"  
                    solo                  
                    ></v-select>   

                    <v-subheader class="caption">What are you up to?:</v-subheader>
                    <v-select
                    v-model="activity"
                    :items="activityoptions"
                    label="What are you doing?"
                    required
                    :rules="dropdownRules"  
                    solo                  
                    ></v-select>   

                    <v-subheader class="caption">Enter Details:</v-subheader>
                    <wysiwyg v-model="comment" />
                    <!--
                    <v-textarea
                        v-model="comment"
                        placeholder="Enter details."
                        auto-grow                        
                        height=20
                        required                                    
                        :rules="textareaRules"      
                        outline                  
                    ></v-textarea>
                    -->
                    <v-btn
                        dark
                            color="primary" 
                            @click="addCheckIn"
                            :disable="!validCheckin"
                    >
                        Submit Checkin
                    </v-btn>                            

                    </template>
                </v-form>
                    </v-card-text>
                    <v-card-actions>

                    <br/><br/>
                    </v-card-actions>
                </v-card>
                
                </v-flex>
                </v-layout>
                </v-dialog>
                </v-flex>



                <v-flex xs12 pa-0>
                <v-dialog v-model="panelPhoto"
                fullscreen
                pa-0
                
                
                >

                <v-layout >
                <v-flex xs12>
                    <v-toolbar dark color="primary">
                        <v-toolbar-side-icon @click="closeCheckin">
                        <v-icon>close</v-icon>
                                                        
                        </v-toolbar-side-icon>
                        <v-toolbar-title>View Checkin Details</v-toolbar-title>

                    </v-toolbar>                      
                <v-card raised pa-2 
                    height="820"
                >
                    
                    <v-card-title>
                        <v-layout row v-if="currcheckin && member.userid ===currcheckin.userid">

                        <v-flex xs12>
                            <div>
                                <!--
                                <v-subheader class="primary--text "><v-icon class="pr-1" color="primary">add_a_photo</v-icon>Upload an image</v-subheader>
                                <input type="file" accept="image/*" @change="detectFiles($event.target.files)">
                                <v-progress-linear
                                v-if="progressUpload>0"
                                :size="100"
                                :width="15"
                                :value="progressUpload"
                                color="primary lighten-1"
                                >
                                {{ progressUpload }}                                    
                                </v-progress-linear>  
                                -->
                                <v-subheader @click="openFileDialog()" class="primary--text font-weight-bold caption"><v-icon>photo_camera</v-icon>Upload an Image</v-subheader>
                                <input ref="fileinput" style="position:absolute;top:-200px;" type="file" accept="image/*" @change="detectFiles($event.target.files)">
                                <img ref="image_preview" style="position:absolute;top:-900px;" src=""/>
                                <v-progress-linear
                                v-if="progressUpload>0"
                                :size="100"
                                :width="15"
                                :value="progressUpload"
                                color="primary lighten-1"
                                >
                                {{ progressUpload }}                                    
                                </v-progress-linear>                                    
                            </div>   
                        </v-flex>  
                        </v-layout>
                        <v-layout row>                               
                        <v-flex xs12 pt-3>
                            <template  v-if="currcheckin && currcheckin.images && currcheckin.images.length>0">
                            <div>
                                
                                <gallery  v-if="currcheckin.images && currcheckin.images.length>0" :images="currcheckin.images.map(i=>{return i.fileurl})" :index="index" @close="index = null"></gallery>
                                <v-avatar
                                    v-if="currcheckin.images && currcheckin.images.length>0"
                                    :tile=true
                                    size="90"
                                    v-for="(image, imageIndex) in currcheckin.images.map(i=>{return i.fileurl})"
                                    :key="imageIndex"
                                    @click="index = imageIndex"
                                >
                                    <img :src="image">
                                </v-avatar>
                        
                            </div>
                            </template>                    
                        </v-flex>                    
                        </v-layout>
                    </v-card-title>

                <v-card-text>
               


                <template v-if="currcheckin && currcheckin.address">
                    <v-text-field
                        v-if="currcheckin.placename"
                        v-model="currcheckin.placename"
                        readonly
                    >

                    </v-text-field>   

                    <v-text-field
                    readonly
                        v-model="currcheckin.address"
                    >

                    </v-text-field>

                    <v-text-field
                    readonly
                        v-model="currcheckin.expiringdatetime"
                        label="How long will they be there?"
                    >

                    </v-text-field>                    
                 
                    <v-text-field
                        readonly
                        v-model="currcheckin.activity"
                        label="What are they doing?"
                    >

                    </v-text-field>   


                    </template>
                    </v-card-text>
                    <v-card-actions>
                        <v-layout row wrap xs12>
                            <v-flex xs12  pt-0 pb-0 > 
                                <div v-if="currcheckin && currcheckin.name" class="primary--text text--darken-1 xs12"><v-icon color="primary darken-1">person</v-icon>{{currcheckin.name}} - {{currcheckin.line}} </div>
                            </v-flex>

                            <v-flex xs12  pt-0 pb-0 v-if="currcheckin && currcheckin.comment"> 
                                <div v-if="currcheckin.comment" class="grey--text comment pl-4 xs12" v-html="currcheckin.comment"></div>
                            </v-flex>
                        </v-layout>                        
                    <br/>
                    </v-card-actions>
                </v-card>
                
                </v-flex>
                </v-layout>
                </v-dialog>
                </v-flex>
            </v-layout>

  </v-layout>
  </v-container>
</template>

<script>
import VueGallery from 'vue-gallery'
import wysiwyg from "vue-wysiwyg"

  import firebase from 'firebase'
  var googleMapsClient = require('@google/maps').createClient({
  key: 'AIzaSyCsjfdV7bEDGipipk6ILx7BN2vJcL7g-fQ'
});

  export default {
    data () {
        return {   
            validCheckin: false,
            textareaRules: [
                v => !!v || 'Field is required',
                v => (v && v.length >= 10) || 'Field must be greater than 10 characters'
            ],            
            textfieldRules: [
                v => !!v || 'Field is required',
                v => (v && v.length >= 4) || 'Field must be greater than 4 characters'
            ],   
            dropdownRules: [
                v => !!v || 'Field is required'
            ],                       
            progressUpload: 0,
            file: File,
            fileIsImage: false,
            filename: null,
            filetype: null,
            filepath: null,
            uploadTask: '',            
            
            index: null,

            panel: false,
            panelPhoto: false,
            currcheckin: null,
            snackbar: false,
            snackbarText: null,
            durationOptions: [1,2,3,4,5,6,7,8],
            durationvalue: 1,
            durationunit: 'hour',
            position: null,
            mapcenter: {lat:34.00,lng:-81.0348},
            coordinates: null,
            address: null,
            placename: null,
            activity: null,
            comment: null,
            activityoptions: ['Eating', 'Fellowshiping', 'Meeting', 'Networking' , 'Partying'],
            tmpcount: 0
            

           
        }
    },
    components: {
        'gallery': VueGallery
    },    
    created () {

        //TODO: variablize the entire page to be used for all post types based this.$route.path
        //console.log('.............route.name = ' , this.$route)
        //this.$store.dispatch('loadSortedLinesAndMembers', {chapter: 'zz'})

   
    },
    computed: {
      myColor () {
         return this.$store.getters.myColor
      },         
      user () {
        return this.$store.getters.user
      },
      member () {
        return this.$store.getters.member
      },
      colorMain () {
          return this.$store.getters.colorMain
      },
      sortedLinesAndMembers () {
          return this.$store.getters.sortedLinesAndMembers
      },
      checkinsActive () {
          return this.$store.getters.checkinsActive
      },
      checkins (){
          var tmp = [
        {
            "lat": 23.2331,
            "lng": 43.23
        },
        {
            "lat": 44.322,
            "lng": 93.423
        },
        {
            "lat": 44.322,
            "lng": 93.423
        }

    ]
        var markers = new Array()
        tmp.forEach(function (e){
            var marker = {position: e}
            markers.push(marker)
        })
        return markers
          
      },
      checkinimages () {
          var rtn = null
          if(this.currcheckin && this.currcheckin.images && this.currcheckin.images.length>0){
              rtn = this.currcheckin.images.map(i=>{
                  return i.fileurl

              })
          }
          return rtn
      }           
    },
    
    watch: {
        checkinsActive : function (value){
            if(value && value.length>0){
                this.mapcenter = value[value.length-1].position

                if(this.currcheckin){
                    var updatedCurrCheckin =value.find(c=>{
                        return c.checkinid ===this.currcheckin.checkinid
                    })
                    if(updatedCurrCheckin){
                        this.currcheckin= updatedCurrCheckin
                    }
                }
            }
            
        },
        address : function(value){
            //console.log('inside address watcher', value)
            if(value!=null){
                 
                this.panel =true
            }else{
                this.panel = false
            }
        },
        panelPhoto: function (value){
            if(value===false){
                this.currcheckin = null
            }
        },
        uploadTask: function(value) {
            value.on('state_changed', sp => {
                this.progressUpload = Math.floor(sp.bytesTransferred / sp.totalBytes * 100)
            }, 
            null, 
            () => {
                value.snapshot.ref.getDownloadURL().then(downloadURL => {
                    //console.log('downloadURL', downloadURL)
                    this.$emit('url', downloadURL)

                    this.$store.dispatch('addFileToUploadHistory', {checkin: this.currcheckin, fileurl: downloadURL, filepath: this.filepath}).then(errmsg => {
                        //console.log('msg', errmsg)
                        if(errmsg && errmsg ==='failure'){
                            console.error('Checkin addFileToUploadHistory', errmsg) 
                        }else{
                            //console.log('successfully added file addFileToUploadHistory') 

                            if(this.fileIsImage){
                                if(!this.currcheckin.images){
                                    this.currcheckin.images = new Array()
                                }
                                this.currcheckin.images.push(downloadURL)
                                this.$store.dispatch('addFileToCheckin', {checkin: this.currcheckin, fileurl: downloadURL, filename: this.filename , filetype: this.filetype, isImage: this.fileIsImage, filepath: this.filepath}).then(errmsg => {
                                    //console.log('msg', errmsg)
                                    if(errmsg && errmsg ==='failure'){
                                        console.error('addFileToCheckin', errmsg) 
                                    }else{
                                        //console.log('successfully added file to post') 
                                        
                                    }
                                })                                   
                            } 
                            this.fileIsImage = false
                            this.filename = null
                            this.filetype = null
                            this.filepath = null

                        }
                    })                      

                })
            })
        }        
    },
    methods: {
        openFileDialog: function (){
            var inputbutton = this.$refs.fileinput
            //console.log('inputbutton',inputbutton)
            inputbutton.click()

        },             
        openSnackBar: function (){
            this.snackbar = true
        },
        closeSnackBar: function (){
            this.snackbar = false
            this.snackbarText = null
        },
        viewCheckin: function (c) {
          //console.log('called viewCheckin', c)
          this.currcheckin = c
          this.panelPhoto = true

        },        
        closeCheckin: function(){
            this.panelPhoto = false
        },
        getLocation: function (){
            this.address = null
            var msg =null
            this.getCoordinates().then(value=>{
                var coord = value
                var latlng = {lat: parseFloat(coord.latitude), lng: parseFloat(coord.longitude)}
                this.position = latlng
                console.log("requesting geocode for latlng", latlng)

                
                    //console.log('inside vuescript2loader')
                    var geocoder = new google.maps.Geocoder
                    geocoder.geocode({'location': latlng}, (results, status)=> {
                           var placesObj = new Object()
                           console.log('inside geocode results',results)
                            if (status === 'OK') {
                                if (results[0]) {
                                    //console.log('results[0].formatted_address', results[0].formatted_address)
                                    this.address = results[0].formatted_address
                                    //console.log('this.address ' + this.address)
                                    //console.log('results[0].place_id', results[0].place_id)
                                    this.place_id = results[0].place_id
                                    //console.log('results[0]', results[0])

                                    placesObj.placeId = results[0].place_id
                                    
                                    var  map = new google.maps.Map(document.getElementById('m2'), {
                                        zoom: 15
                                    });
                                    //console.log('map = ', map)

                                    var service = new google.maps.places.PlacesService(map)
                                    //console.log('service = ', service)
                                    //console.log('placesObj.placeId = ', placesObj.placeId)
                                    if(placesObj.placeId){
                                        //console.log('placesObj.placeId = ', placesObj.placeId)
                                        service.getDetails({
                                            placeId: placesObj.placeId}, (place, status)=>{
                                            //console.log('getDetails start')
                                            if (status == google.maps.places.PlacesServiceStatus.OK) {
                                                for (var i = 0; i < results.length; i++) {
                                                var place = results[i];
                                                //console.log('getDetails loop place.name = ' + place.name)
                                                //console.log('getDetails loop place = ' , place)
                                                if(place.name){
                                                    this.placename = place.name
                                                }
                                                }
                                            }
                                            //console.log('getDetails done')                                        
                                        });
                                    }else{
                                        //console.log('placesObj.placeId not set') 
                                    }

                                    
                                
                                } else {
                                window.alert('No results found');
                                }
                            } else {
                                window.alert('Geocoder failed due to: ' + status);
                            }
                            });                    

            }).catch(function (value){
                msg =value.message
            }) 
            if(msg){
                this.snackbarText =msg
                this.openSnackBar()
            }           
            
        },
        condensePanel: function (){
            this.panel=false
        },
        addFakeCheckin : function (){
          var tmp = [
        {
            
            "lat": 34.1722980,
            "lng":  -80.8764678
        },
        {
            "lat": 34.074819,
            "lng": -80.94459
        },
        {
            "lat": 34.070909,
            "lng": -80.958875
        }

    ]            

            
            this.durationvalue = 1
            this.durationunit = 'hour'
            this.position = tmp[1]
            this.addFakeCheckin()            


        },
        addCheckIn : function (){




            var tmpObjPayload = new Object()
            tmpObjPayload.member = this.$store.getters.member

            tmpObjPayload.expiringmarker = new Object()
            tmpObjPayload.expiringmarker.duration = new Object()
            tmpObjPayload.expiringmarker.duration.value = this.durationvalue
            tmpObjPayload.expiringmarker.duration.unit = this.durationunit
            tmpObjPayload.expiringmarker.position = this.position
            if(this.activity){
                tmpObjPayload.expiringmarker.activity = this.activity
            }
            if(this.placename){
                tmpObjPayload.expiringmarker.placename = this.placename
            }
            if(this.address){
                tmpObjPayload.expiringmarker.address = this.address            
            }
            if(this.comment){
                tmpObjPayload.expiringmarker.comment = this.comment            
            }            

            this.$store.dispatch('addCheckIn', tmpObjPayload).then(errmsg => {
            //console.log('msg', errmsg)
            if(errmsg && errmsg ==='failure'){
                console.error('addCheckin', errmsg) 
                this.snackbarText="Failed to send message."
                this.openSnackBar()
            }else{
                //console.log('successfully added message') 
                this.snackbarText="Message successfully sent."
                this.openSnackBar()
                this.panel=false
            }
            })

        },
        whereami: function () {
            this.getCoordinates().then(function(value){
                var coord = value
            }).catch(function (value){
                alert(value.message)
            })
        },
        getCoordinates: function() {



         return new Promise(function(resolve, reject) {
            var options = {
                timeout: 15000,
                maximumAge: 0,
                //enableHighAccuracy: true
            }

/*            
            var loc = {};
            var geocoder = new google.maps.Geocoder()
            if(google.loader.ClientLocation) {
                console.log('finding loc ')
                loc.lat = google.loader.ClientLocation.latitude;
                loc.lng = google.loader.ClientLocation.longitude;
                console.log('loc ', loc)
                var latlng = new google.maps.LatLng(loc.lat, loc.lng);
                geocoder.geocode({'latLng': latlng}, function(results, status) {
                    if(status == google.maps.GeocoderStatus.OK) {
                        alert(results[0]['formatted_address']);
                    };
                });
                console.log('resolving ', loc)
                resolve(loc)

            }
*/


        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(pos => {
                //console.log('pos',pos)
                var crd = pos.coords


                //console.log('Your current position is:')
                //console.log(`Latitude : ${crd.latitude}`)
                //console.log(`Longitude: ${crd.longitude}`)
                //console.log(`More or less ${crd.accuracy} meters.`)
                //console.log('resolving ', crd)
                resolve(crd)

            }, err => {
                console.error(`ERROR(${err.code}): ${err.message}`, err)
            }, options)

        }else{
            console.error('navigator empty?? ', navigator.geolocation)
        }

           
          })
          
        },
        detectFiles: function (fileList) {
        Array.from(Array(fileList.length).keys()).map( x => {
            this.upload(fileList[x])
        })
        },   
        upload: function (file) {
            if(file.type.indexOf('image')>-1){
                this.fileIsImage = true
                var dataUrl = "";
                // Create an image
                var img = document.createElement("img");
                img.addEventListener('load', ()=> {
                // execute drawImage statements here
                   var canvas = document.createElement("canvas");
                    //var canvas = $("<canvas>", {"id":"testing"})[0];
                    var ctx = canvas.getContext("2d");
                    ctx.drawImage(img, 0, 0);            
                    // Set Width and Height
                    var MAX_WIDTH = 400;
                    var MAX_HEIGHT = 300;
                    var width = img.width;
                    var height = img.height;            
                    if (width > height) {
                    if (width > MAX_WIDTH) {
                        height *= MAX_WIDTH / width;
                        width = MAX_WIDTH;
                    }
                    } else {
                    if (height > MAX_HEIGHT) {
                        width *= MAX_HEIGHT / height;
                        height = MAX_HEIGHT;
                    }
                    }
                    canvas.width = width;
                    canvas.height = height;
                    var ctx = canvas.getContext("2d");
                    ctx.drawImage(img, 0, 0, width, height);            
                    //console.log('calling canvas',canvas)
                    dataUrl = canvas.toDataURL(file.type);                    
                    this.$refs.image_preview.src = dataUrl;    
                    //console.log('calling dataUrl', dataUrl)
                    this.filename = new Date().getTime() + '_' + file.name
                    this.filetype = file.type
                    this.filepath = this.currcheckin.org + '_' + this.currcheckin.chapter + '/checkins/' +  this.filename

                    this.uploadTask = firebase.storage().ref(this.filepath).putString(dataUrl, 'data_url')
                }, false);            
                // Create a file reader
                var reader = new FileReader();
                // Set the image once loaded into file reader
                reader.onload = (e)=>
                {
                    //console.log('calling reader.onload  e', e)

                    img.src = e.target.result;
                    //console.log('calling reader.onload  img', img)                   
                }
                // Load files into file reader
                reader.readAsDataURL(file);               

            }
        }           
        /*     
        upload: function (file) {
            if(file.type.indexOf('image')>-1){
                this.fileIsImage = true
            }
            
            this.filename = new Date().getTime() + '_' + file.name
            this.filetype = file.type
            this.filepath = this.currcheckin.org + '_' + this.currcheckin.chapter + '/checkins/' +  this.filename
            this.uploadTask = firebase.storage().ref(this.filepath).put(file);
        } 
        */

                      
    }
  }
</script>

<style>
#postFieldList .v-subheader{
    width:110px;
    padding-left: 0px;
    background-color: ghostwhite;
    margin-right: 8px;
}

#postComments .v-card{
    background-color:blue;
}
#fieldContainer .v-card__text{
    padding:5px;
}
.fieldlabel, .fieldlabel .v-card{
    background-color: ghostwhite;
    text-align: left;
}
.loc-card{
  border-radius:15px;
  padding-left:10px;
  margin-right:10px;  
  
}

.chat-card-me{
  border-radius:15px;
  padding-left:10px;
  margin-right:10px;  
  
}

.chat-card-date{
    text-align: right;
    margin-right:15px;
    color:dimgrey;
}
</style>